export default "__VITE_ASSET__7ENirbpY__"